import { useAuth } from "@/contexts/AuthContext";

/**
 * Shorthand para acessar o clube selecionado no AuthContext.
 *
 * O AuthContext ja gerencia carregamento, multi-club selection e
 * propaga `club: Club | null`. Este hook expoe apenas o subconjunto
 * `{ club }` para componentes que nao precisam do resto do contexto
 * (ex.: BillingStrategySettings).
 */
export function useClub() {
  const { club } = useAuth();
  return { club };
}
